import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa'; 
import './SearchInput.css'

const SearchInput = ({ id, placeholder, value, name, onChange, onClick }) => {

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (onClick) {
                onClick(e);
            }
        }
    };

    return (
        <div id={id} className="search-input-container">
            <input
                type="text"
                className="search-input-field"
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                name={name}
                onKeyDown={handleKeyDown}
            />
            <div id='search-icon-wrapper'>
                <FaSearch id='search-icon' onClick={onClick} />
            </div>
        </div>
    );
};

export default SearchInput;
